export function formatHeat(n: number): string {
  if (n >= 10000) {
    return `${(n / 10000).toFixed(1)}万`;
  }
  return String(n);
}

export function formatDate(date: string): string {
  return date.replace(/-/g, ".");
}

export function typeLabel(type: string): string {
  if (type === "news") return "新闻";
  if (type === "video") return "视频";
  if (type === "encyclopedia") return "百科";
  return "内容";
}

export function typePath(type: string): string {
  if (type === "video") return "/video";
  if (type === "encyclopedia") return "/encyclopedia";
  return "/news";
}